import React, { useEffect } from "react";
import filterIcon from "../img/filter_icon_menu.svg";
import FilterOverlayItem from "./FilterOverlayItem";
import closeMenuIcon from "../img/close_menu.svg";

export default function FilterOverlay({
  data,
  hideFilterOverlay,
  filterImages,
  setFilterImages,
  images,
  filters,
  setFilters,
  findImages,
}) {
  function handleChange(e) {
    let newFilterValue;
    if (e.target.checked) {
      newFilterValue = [...filters, parseInt(e.target.id, 10)];
    } else {
      newFilterValue = [...filters];
      newFilterValue = newFilterValue.filter(function (value, index, arr) {
        return value !== parseInt(e.target.id, 10);
      });
    }
    setFilters(newFilterValue);
  }

  function handleClose() {
    hideFilterOverlay();
  }
  function handleClick(e) {
    setFilters([]);
  }
  useEffect(() => {
    findImages(filters);
  }, [filters, findImages]);

  return (
    <div className="overlay">
      <div className="overlaybg" onClick={handleClose}></div>
      <div className="overlayHolder">
        <div className="menu">
          <div className="menuitems">
            <img
              src={filterIcon}
              className="filter_icon_menu"
              alt="Filter ikon"
            />
          </div>
          <div className="menuclose">
            <div className="menuitems mouse" onClick={handleClick}>
              Nullstill
            </div>
            <div
              className="menuitems mouse ml3 menuclose"
              onClick={handleClose}
            >
              Lukk <img src={closeMenuIcon} alt="" className="ml1 menu_icon" />
            </div>
          </div>
        </div>
        <div className="filteritems">
          {data.map(function (item) {
            return (
              <FilterOverlayItem
                title={item.title}
                id={item.id}
                key={item.id}
                onChange={handleChange}
                checked={filters.includes(item.id)}
              />
            );
          })}
        </div>
        <div className="btn mouse btnmob" onClick={hideFilterOverlay}>
          Vis {filterImages.length} treff
        </div>
      </div>
    </div>
  );
}
